// @vendors
const set = require('lodash/object/set');
const get = require('lodash/object/get');

const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const moment = require('moment');
const { DATE_FORMAT_API } = require('constants/index');
const errorActions = require('actions/brokerError');

//@constants
const {
    DATE_FILTER_NONE,
    BROKER_JOINT_CONTRACTS_VALUE,
    BROKER_JOINT_CONTRACTS_CRYPTO,
    BROKER_JOINT_CONTRACTS_FUND,
    BROKER_JOINT_CONTRACTS_PLAN,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_EXTRAORDINARY,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC_NO_RESULTS,
    BROKER_CONTRACT_ACTIVITIES_DATE_LIMIT_YEARS_FROM_NOW,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER_INITIAL_DATE,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_REJECTED,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_OPERATION_SELECTED,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES
} = require('constants/index');

// @Contact Center
const { ERROR_PENSION_PLAN_NO_EXTRAORDINARY_CONTRIBUTIONS_TO_CANCEL } = require('constants/contactCenter/errorTypes');

const DATE_LIMIT = moment()
    .subtract(BROKER_CONTRACT_ACTIVITIES_DATE_LIMIT_YEARS_FROM_NOW, 'years')
    .format(DATE_FORMAT_API); // This is a limit in the API endpoint

const requestContractActivitiesSuccess = (data, contractId, productNumber, productSubtype, contractType) => ({
    type: actionTypes.BROKER_GET_CONTRACT_ACTIVITIES_SUCCESS,
    payload: {
        data,
        contractId,
        productNumber,
        productSubtype,
        contractType,
    }
});

const requestContractActivitiesFailure = (error, contractId, productNumber, productSubtype, contractType) => ({
    type: actionTypes.BROKER_GET_CONTRACT_ACTIVITIES_FAILURE,
    payload: {
        error,
        contractId,
        productNumber,
        productSubtype,
        contractType,
    }
});

const requestContractActivitiesFetching = contractId => ({
    type: actionTypes.BROKER_GET_CONTRACT_ACTIVITIES_REQUEST,
    payload: {
        contractId
    }
});

const requestContractRejectedActivitiesFetching = contractId => ({
    type: actionTypes.BROKER_GET_CONTRACT_REJECTED_ACTIVITIES_REQUEST,
    payload: {
        contractId
    }
});

const requestContractRejectedActivitiesSuccess = (data, contractId, productNumber, productSubtype, contractType, nameOfOperation) => ({
    type: actionTypes.BROKER_GET_CONTRACT_REJECTED_ACTIVITIES_SUCCESS,
    payload: {
        data,
        contractId,
        productNumber,
        productSubtype,
        contractType,
        nameOfOperation
    }
});

const requestContractRejectedActivitiesFailure = (error, contractId, productNumber, productSubtype, contractType) => ({
    type: actionTypes.BROKER_GET_CONTRACT_REJECTED_ACTIVITIES_FAILURE,
    payload: {
        error,
        contractId,
        productNumber,
        productSubtype,
        contractType,
    }
});

const requestRejectedOperationCodeSuccess = (data, contractId, productNumber, productSubtype, contractType) => ({
    type: actionTypes.BROKER_GET_CONTRACT_REJECTED_CODE_SUCCESS,
    payload: {
        data,
        contractId,
        productNumber,
        productSubtype,
        contractType
    }
});

const requestRejectedOperationCodeFailure = (error, contractId, productNumber, productSubtype, contractType) => ({
    type: actionTypes.BROKER_GET_CONTRACT_REJECTED_CODE_FAILURE,
    payload: {
        error,
        contractId,
        productNumber,
        productSubtype,
        contractType,
    }
});

const setFilter = (filter, contractId) => ({
    type: actionTypes.BROKER_GET_CONTRACT_ACTIVITIES_SET_FILTER,
    payload: {
        filter,
        contractId
    }
});

const clearFilter = contractId => ({
    type: actionTypes.BROKER_GET_CONTRACT_ACTIVITIES_CLEAR_FILTER,
    payload: {
        contractId
    }
});

const requestActivityDetailsFailure = (error, contractId, activityId) => ({
    type: actionTypes.BROKER_GET_CONTRACT_ACTIVITY_DETAILS_FAILURE,
    payload: {
        error,
        contractId,
        activityId
    }
});

const requestActivityDetailsSuccess = (data, contractId, activityId, movementType, cancellableMovements, isConditionatedOrder) => ({
    type: actionTypes.BROKER_GET_CONTRACT_ACTIVITY_DETAILS_SUCCESS,
    payload: {
        data,
        cancellableMovements,
        contractId,
        activityId,
        movementType,
        isConditionatedOrder
    }
});

const requestActivityDetailsFetching = (contractId, activityId) => ({
    type: actionTypes.BROKER_GET_CONTRACT_ACTIVITY_DETAILS_REQUEST,
    payload: {
        contractId,
        activityId
    }
});

const getOrders = (immContract, history, queryParams, apiEndpoint, contractType) => (dispatch, getState) => {
    const productNumber = immContract.get('productNumber');
    const contractNumber = immContract.get('walletNumber');
    const requestData = {
        query: {
            ...queryParams,
        },
        header: {},
    };

    if (contractType === BROKER_JOINT_CONTRACTS_CRYPTO) {
        requestData.header.version = 1;
        requestData.query.fromDate = moment(DATE_LIMIT).format(DATE_FORMAT_API);
        requestData.query.toDate = moment().startOf('day').format(DATE_FORMAT_API);
    } else {
        requestData.query.fechaDesde = moment(DATE_LIMIT).format(DATE_FORMAT_API);
        requestData.query.fechaHasta = moment().startOf('day').format(DATE_FORMAT_API);
    };

    dispatch(requestContractActivitiesFetching(contractNumber));
    const immFilters = getState().brokerContractActivities.getIn([contractNumber, 'filters']);


    if (immFilters) {
        if (
            immFilters.getIn(['date', 'isActive']) &&
            immFilters.getIn(['date', 'selected']) !== DATE_FILTER_NONE
        ) {
            const dateFrom = immFilters.getIn(['date', 'from']);
            const dateTo = immFilters.getIn(['date', 'to']);
            const dateFromValid = moment(dateFrom || DATE_LIMIT).isAfter(DATE_LIMIT);
            const dateToValid = moment(dateTo).isAfter(DATE_LIMIT);

            if (contractType === BROKER_JOINT_CONTRACTS_CRYPTO) {
                requestData.header.version = 1;
                requestData.query.fromDate = dateFromValid
                ? moment(dateFrom).format(DATE_FORMAT_API)
                : DATE_LIMIT;
            requestData.query.toDate = dateToValid
                ? moment(dateTo).format(DATE_FORMAT_API)
                : DATE_LIMIT;
            } else {
                requestData.query.fechaDesde = dateFromValid
                ? moment(dateFrom).format(DATE_FORMAT_API)
                : DATE_LIMIT;
            requestData.query.fechaHasta = dateToValid
                ? moment(dateTo).format(DATE_FORMAT_API)
                : DATE_LIMIT;
            };
        }

        if (immFilters.getIn(['state', 'isActive'])) {
            requestData.query.situacionCombo = immFilters.getIn(['state', 'value']);
        }

        if (immFilters.getIn(['state', 'isActive']) && immFilters.getIn(['state', 'value']).trim() !== '') {
            requestData.query.situacionCombo = immFilters.getIn(['state', 'value']).trim();
        }
    }   

    __CONTACT_CENTER__ && dispatch(requestContractActivitiesFetching(contractNumber));
    return APIGet(dispatch, apiURLBuilder.getURL(apiEndpoint), requestData)
        .then(response => {
            dispatch(
                requestContractActivitiesSuccess(
                    response,
                    contractNumber,
                    productNumber,
                    null,
                    contractType
                )
            );
        })
        .catch(error => {
            dispatch(
                requestContractActivitiesFailure(
                    error,
                    contractNumber,
                    null,
                    null,
                    contractType
                )
            );
            const errorKey = get(error, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const getCryptoOrders = (immContract, history) => {
    const portfolioId = immContract.get('walletNumber');
    const queryParams = { portfolioId };
    return getOrders(immContract, history, queryParams, 'contractCryptoOrders', BROKER_JOINT_CONTRACTS_CRYPTO);
};

const getValueOrders = (immContract, history) => {
    const productNumber = immContract.get('productNumber');
    const contractNumber = immContract.get('walletNumber');
    const queryParams = { producto: productNumber, numeroContrato: contractNumber };
    return getOrders(immContract, history, queryParams, 'contractValueActivities', BROKER_JOINT_CONTRACTS_VALUE);
};

const getNewFundMovements = (immContract, orderState, immDate, codOperation) => dispatch => {
    const contractId = immContract.get('walletNumber');
    const productNumber = immContract.get('productNumber');
    const productSubtype = immContract.get('productSubtype');
    const startDate = immDate.get('from');
    const endDate = immDate.get('to');
    let requestData, endpoint;

    switch (orderState) {
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING: {
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId,
                }
            };
            endpoint = 'contractFundActivitiesPending';
        } break;
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED: {
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId,
                }
            };
            endpoint = 'contractFundActivitiesConsolidated';
        } break;
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED:
        default:
            {
                requestData = {
                    query: {
                        contratoClienteProducto: productNumber,
                        contratoClienteNumero: contractId,
                    }
                };
                endpoint = 'contractFundActivitiesCancelled';
            }
            break;
    }

    requestData = {
        query: {
            ...requestData.query,
            fechaInicio: startDate ? startDate : moment().startOf('day').year(2005).format(DATE_FORMAT_API),
            fechaFin: endDate ? endDate : moment().startOf('day').format(DATE_FORMAT_API),
            codOperacion: codOperation,
        }
    }

    dispatch(requestContractActivitiesFetching(contractId));
    return APIGet(dispatch, apiURLBuilder.getURL(endpoint), requestData).then(
        response => {
            dispatch(
                requestContractActivitiesSuccess(
                    response,
                    contractId,
                    productNumber,
                    productSubtype,
                    BROKER_JOINT_CONTRACTS_FUND
                )
            );
        },
        error => {
            dispatch(requestContractActivitiesFailure(error, contractId));
        }
    );
}

const getFundMovements = (immContract, selectedOption) => dispatch => {
    const contractId = immContract.get('walletNumber');
    const productNumber = immContract.get('productNumber');
    const productSubtype = immContract.get('productSubtype');
    let requestData, endpoint;

    switch (selectedOption) {
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING: {
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId
                }
            };
            endpoint = 'contractFundActivitiesPending';
        } break;
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED: {
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId,
                    fechaInicio: moment().startOf('day').year(2005).format(DATE_FORMAT_API), // @hardcoded
                    fechaFin: moment().startOf('day').format(DATE_FORMAT_API)
                }
            };
            endpoint = 'contractFundActivitiesConsolidated';
        } break;
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED:
        default:
            {
                requestData = {
                    query: {
                        contratoClienteProducto: productNumber,
                        contratoClienteNumero: contractId
                    }
                };
                endpoint = 'contractFundActivitiesCancelled';
            }
            break;
    }

    dispatch(requestContractActivitiesFetching(contractId));
    return APIGet(dispatch, apiURLBuilder.getURL(endpoint), requestData).then(
        response => {
            dispatch(
                requestContractActivitiesSuccess(
                    response,
                    contractId,
                    productNumber,
                    productSubtype,
                    BROKER_JOINT_CONTRACTS_FUND
                )
            );
        },
        error => {
            dispatch(requestContractActivitiesFailure(error, contractId));
        }
    );
};

const getFundDetails = immMovement => dispatch => {
    const contractId = immMovement.get('contractNumber');
    const productNumber = immMovement.get('productNumber');
    const fundCode = immMovement.get('fundCode');
    let requestData, endpoint;
    const emittedDate = immMovement.get('dateOriginal');

    switch (immMovement.get('state')) {
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING: {
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId,
                    codSubtipoProducto: immMovement.get('productSubtype'),
                    codOperacion: immMovement.get('operationCode'),
                    numSecuenciaOper: immMovement.get('sequenceNumber'),
                    fechaSolicitud: immMovement.get('dateRequested'),
                    tipoPeticion: immMovement.get('requestType'),
                    codEstado: immMovement.get('stateCode'),
                    codFondo: fundCode,
                    moneda: immMovement.getIn(['import', 'currency']),
                    participacionesPeticion: immMovement.getIn(['import', 'amount']),
                    fechaValorEditada: emittedDate || ''
                }
            };
            endpoint = 'contractFundActivityDetailsPending';
        } break;
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED: {
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId,
                    codSubtipoProducto: immMovement.get('productSubtype'),
                    numSecuencialOper: immMovement.get('sequenceNumber'),
                    codOperacion: immMovement.get('operationCode'),
                    fechaSolicitud: immMovement.get('dateRequested'),
                    fechaValorEmitida: immMovement.get('dateValue'),
                    divisa: immMovement.getIn(['import', 'currency']),
                    importe: immMovement.getIn(['import', 'amount']),
                    moneda: immMovement.getIn(['import', 'currency'])
                }
            };
            endpoint = 'contractFundActivityDetailsConsolidated';
        } break;
        case BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED:
        default:
            {
                requestData = {
                    query: {
                        contratoClienteNumero: contractId,
                        contratoClienteProducto: productNumber,
                        codigoSubtipoProducto: immMovement.get('productSubtype'),
                        numSecuenceOperacion: immMovement.get('sequenceNumber'),
                        fechaSolicitud: immMovement.get('dateRequested'),
                        importe: immMovement.getIn(['import', 'amount']),
                        divisa: immMovement.getIn(['import', 'currency'])
                    }
                };
                endpoint = 'contractFundActivityDetailsCancelled';
            }
            break;
    }

    dispatch(requestActivityDetailsFetching(contractId, immMovement.get('id')));
    return APIGet(dispatch, apiURLBuilder.getURL(endpoint), requestData)
        .then(response =>
            dispatch(
                requestActivityDetailsSuccess(
                    response,
                    contractId,
                    immMovement.get('id'),
                    immMovement.get('state')
                )
            )
        )
        .catch(error =>
            dispatch(requestActivityDetailsFailure(error, contractId, immMovement.get('id')))
        );
};

const getPlanMovements = (immContract, selectedOption) => dispatch => {
    const contractId = immContract.get('walletNumber');
    const productNumber = immContract.get('productNumber');
    let requestData, endpoint;

    switch (selectedOption) {
        case BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER: {
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId,
                    fechaInicio: BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER_INITIAL_DATE,
                    fechaFin: moment().startOf('day').format(DATE_FORMAT_API)
                }
            };
            endpoint = 'contractPlanActivitiesOther';
        } break;
        case BROKER_ORDERS_AND_MOVEMENTS_PLAN_EXTRAORDINARY: {
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId,
                    codOperacionSel: __CONTACT_CENTER__ ? BROKER_ORDERS_AND_MOVEMENTS_PLAN_OPERATION_SELECTED : 'PSE',
                    indPaginacion: 'N'
                }
            };
            endpoint = 'contractPlanActivitiesExtraordinary';
        } break;
        case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES:
            requestData = {
                query: {
                    producto: productNumber,
                    numeroContrato: contractId
                }
            };
            endpoint = 'brokerPlanesMovimientosPendientes';
            break;
        case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC:
        default:
            {
                requestData = {
                    query: {
                        producto: productNumber,
                        numeroContrato: contractId
                    }
                };
                endpoint = 'contractPlanActivitiesPeriodic';
            }
            break;
    }

    dispatch(requestContractActivitiesFetching(contractId));
    return APIGet(dispatch, apiURLBuilder.getURL(endpoint), requestData)
        .then(response => {
            dispatch(requestContractActivitiesSuccess(response, contractId, productNumber, selectedOption, BROKER_JOINT_CONTRACTS_PLAN));
        })
        .catch(error => {
            if (selectedOption == BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC) {
                set(error, ['body', 'error'], BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC_NO_RESULTS);
            }
            dispatch(requestContractActivitiesFailure(error, contractId, productNumber, selectedOption, BROKER_JOINT_CONTRACTS_PLAN));
        });
};

const getPlanDetails = immMovement => dispatch => {
    if (immMovement.get('movementType') === BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC) {
        const contractId = immMovement.get('contractNumber');
        const productNumber = immMovement.get('productNumber');
        const indRevalAnual = immMovement.get('indRevalAnul');
        const requestData = {
            query: {
                producto: productNumber,
                numeroContrato: contractId,
                timeStamp: immMovement.get('timeStamp'),
                tipoApor: immMovement.get('operation')
            }
        };

        if (indRevalAnual === 'S') {
            requestData.query.revalAnual = indRevalAnual;
        }

        dispatch(requestActivityDetailsFetching(contractId, immMovement.get('id')));
        return APIGet(
            dispatch,
            apiURLBuilder.getURL('contractPlanActivityDetailsPeriodic'),
            requestData
        )
            .then(response =>
                dispatch(
                    requestActivityDetailsSuccess(
                        response,
                        contractId,
                        immMovement.get('id'),
                        BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC
                    )
                )
            )
            .catch(error =>
                dispatch(requestActivityDetailsFailure(error, contractId, immMovement.get('id')))
            );
    }
};

const getValueOrderDetails = immMovement => dispatch => {
    const contractId = immMovement.get('contractNumber');
    const activityId = immMovement.get('id');
    const orderNumber = immMovement.get('number');
    const isConditionatedOrder = immMovement.get('isConditionated');
    const requestData = {
        query: {
            producto: immMovement.get('productNumber'),
            numeroContrato: contractId
        }
    };

    const urlParams = {
        orderNumber: orderNumber
    };

    let url = isConditionatedOrder ? 'activityDetailsWithCondition': 'activityDetails';

    dispatch(requestActivityDetailsFetching(contractId, activityId));
    return APIGet(dispatch, apiURLBuilder.getURL(url, urlParams), requestData)
        .then(response =>
            dispatch(
                requestActivityDetailsSuccess(
                    response,
                    contractId,
                    activityId,
                    BROKER_JOINT_CONTRACTS_VALUE,
                    '',
                    isConditionatedOrder
                )
            )
        )
        .catch(error => dispatch(requestActivityDetailsFailure(error, contractId, activityId)));
};

const getCryptoOrderDetails = immMovement => dispatch => {
    const contractId = immMovement.get('contractNumber');
    const activityId = immMovement.get('id');
    const orderNumber = immMovement.get('number');
    const requestData = {
        query: {
            producto: immMovement.get('productNumber'),
            numeroContrato: contractId
        },
        header: {
            version: 1
        },
    };

    const urlParams = {
        orderNumber: orderNumber
    };

    const url = 'cryptoOrderDetails';

    dispatch(requestActivityDetailsFetching(contractId, activityId));
    return APIGet(dispatch, apiURLBuilder.getURL(url, urlParams), requestData)
        .then(response =>
            dispatch(
                requestActivityDetailsSuccess(
                    response,
                    contractId,
                    activityId,
                    BROKER_JOINT_CONTRACTS_CRYPTO,
                    '',
                    false,
                )
            )
        )
        .catch(error => dispatch(requestActivityDetailsFailure(error, contractId, activityId)));
};

const getContractActivities = (immContract, selectedOption, history) => {
    switch (immContract.get('type')) {
        case BROKER_JOINT_CONTRACTS_VALUE:
            return getValueOrders(immContract, history);
        case BROKER_JOINT_CONTRACTS_FUND:
            return getFundMovements(immContract, selectedOption);
        case BROKER_JOINT_CONTRACTS_PLAN:
            return getPlanMovements(immContract, selectedOption);
        case BROKER_JOINT_CONTRACTS_CRYPTO:
            return getCryptoOrders(immContract, history);
    }
};

const getPensionPlanCancellableMovements = (productNumber, contractId, dispatch) => {
    const requestData = {
        query: {
            producto: productNumber,
            numeroContrato: contractId
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('pensionPlanCancellableMovements'), requestData)
        .catch(response => {
            if (get(response, 'body.error') === ERROR_PENSION_PLAN_NO_EXTRAORDINARY_CONTRIBUTIONS_TO_CANCEL) {
                return Promise.resolve();
            } else {
                throw response;
            }
        });
}

const getPlanPendingMoves = immMovement => dispatch => {
    const url = apiURLBuilder.getURL('brokerPlanesMovimientosPendientesDetalles');

    const movementId = immMovement.get('id');
    const contractId = immMovement.get('contractNumber');
    const productNumber = immMovement.get('productNumber');
    const operationCode = immMovement.get('operationCode');

    const requestData = {
        producto: productNumber,
        numeroContrato: contractId,
        codOperacionSel: operationCode
    };

    dispatch(requestActivityDetailsFetching(contractId, movementId));

    return APIGet(dispatch, url, { query: requestData })
        .then(response => {
            if (__CONTACT_CENTER__) {
                return getPensionPlanCancellableMovements(productNumber, contractId, dispatch)
                    .then(pensionPlanCancellableMovementsResponse => {
                        return dispatch(requestActivityDetailsSuccess(response, contractId, movementId, BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES, pensionPlanCancellableMovementsResponse));
                    });
            }

            return dispatch(requestActivityDetailsSuccess(response, contractId, movementId, BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES));
        })
        .catch(error => {
            if (error.error) {
                return dispatch(requestActivityDetailsFailure(error, contractId, movementId))
            }
            throw error;
        });
};

const getRejectedMovements = (immContract, selectedOption) => dispatch => {
    const contractId = immContract.get('walletNumber');
    const productNumber = immContract.get('productNumber');

    return new Promise(function () {
        let requestData, endpoint;
        requestData = {
            query: {
                "fechafin": "2017-09-14",
                "fechainicio": "2011-08-04",
                "numerodecontrato": contractId,
                "producto": productNumber
            }
        }
        endpoint = 'rejectedContractMovements';

        APIPost(dispatch, apiURLBuilder.getURL(endpoint), requestData)
            .then(function (response) {
                dispatch(requestRejectedOperationCodeSuccess(response));
                return response;
            }, function (response) {
                dispatch(requestRejectedOperationCodeFailure(response))
            }
            ).then(function (response) {
                const rejectedCodeList = response.movRechazados.movRechazado;
                return rejectedCodeList;
            }).then(function (rejectedCodeList) {
                let rejectedOperationCode, rejectedOperationName;
                rejectedCodeList.forEach(rejectedCode => {
                    rejectedOperationCode = rejectedCode.codOperacion;
                    rejectedOperationName = rejectedCode.nomOperacion;

                    const requestData = {
                        query: {
                            "codOpSeleccionado": rejectedOperationCode,
                            "fechafin": "2017-09-14",
                            "fechainicio": "2011-08-04",
                            "numerodecontrato": contractId,
                            "producto": productNumber
                        }
                    };
                    dispatch(requestContractRejectedActivitiesFetching(contractId));
                    APIPost(dispatch, apiURLBuilder.getURL('rejectedContractMovementDetails'), requestData)
                        .then(function (response) {
                            dispatch(requestContractRejectedActivitiesSuccess(response, contractId, productNumber, selectedOption, BROKER_ORDERS_AND_MOVEMENTS_PLAN_REJECTED, rejectedOperationName));
                        }, function (error) {
                            dispatch(requestContractRejectedActivitiesFailure(error, contractId, productNumber, selectedOption, BROKER_JOINT_CONTRACTS_PLAN));
                        }
                        );
                });
            });
    });
}

const getActivityDetails = immMovement => {
    switch (immMovement.get('movementType')) {
        case BROKER_JOINT_CONTRACTS_CRYPTO:
            return getCryptoOrderDetails(immMovement);
        case BROKER_JOINT_CONTRACTS_VALUE:
            return getValueOrderDetails(immMovement);
        case BROKER_JOINT_CONTRACTS_FUND:
            return getFundDetails(immMovement);
        case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC:
        case BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER:
            return getPlanDetails(immMovement);
        case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES:
            return getPlanPendingMoves(immMovement);
    }
};

const getRejectedActivities = (immContract, selectedOption) => {
    if (immContract.get('type')) {
        return getRejectedMovements(immContract, selectedOption)
    }
}

module.exports = {
    getContractActivities,
    getActivityDetails,
    getRejectedActivities,
    setFilter,
    clearFilter,
    getNewFundMovements
};
